import {cn} from "../libs/utils";

const ButtonBack = ({onClick, label = '← Volver', className}) => {
    return (
        <button
            className={cn(
                'group flex items-center gap-2 border-2 border-gray-300 text-gray-600',
                'hover:border-ecoprimary1 hover:text-ecoprimary1 hover:bg-blue-50',
                'py-2.5 px-5 rounded-lg font-semibold text-sm',
                'transition-all duration-300 ease-out',
                className
            )}
            onClick={() => onClick()}
        >
            <span className="inline-block transition-transform duration-300 group-hover:-translate-x-1">←</span>
            <span>{label.replace('← ', '').replace('←', '')}</span>
        </button>
    );
};

export default ButtonBack;